var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"thumb portrait-animation-box"},[_c('a',{attrs:{"href":"javascript:void(0)","role":"button"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('on-click')}}},[_c('div',{staticClass:"animation-box-wrapper"},[(_setup.motionThumbnail)?_c('img',{staticClass:"thumb-img",style:({
          display: _setup.isImageLoaded ? 'block' : 'none',
        }),attrs:{"src":_setup.motionThumbnail,"alt":_setup.imageAlt},on:{"load":function($event){return _setup.changeImageLoadedState(true)},"error":function($event){return _setup.changeImageLoadedState(false)}}}):_c(_setup.WebpImage,{attrs:{"image-info":{
          imageUrl: _setup.staticThumbnailInfo.url,
          width: _vm.thumbnailInfo.width,
          height: _vm.thumbnailInfo.height,
          alt: _setup.imageAlt,
          quality: 100,
          className: 'thumb-img',
          envPrefix: _setup.staticThumbnailInfo.envPrefix,
          onImageLoad: () => _setup.changeImageLoadedState(true),
          onImageError: () => _setup.changeImageLoadedState(false),
        }}}),(!_setup.isImageLoaded)?_c('div',{class:['animation-alt-wrapper', { 'no-thumb': !_setup.isImageLoaded }]},[_c('span',[_vm._v(_vm._s(_setup.imageAlt))])]):_vm._e()],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }